module.exports = __webpack_public_path__ + "img/校准认证.dba068da.svg";